<template>
	<el-menu class="navbar" mode="horizontal">
		<hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>
		<breadcrumb></breadcrumb>
		<el-dropdown class="avatar-container" trigger="click">
			<div class="avatar-wrapper">
				<img class="user-avatar" :src="avatar">
				<i class="el-icon-caret-bottom"></i>
			</div>
			<el-dropdown-menu class="user-dropdown" slot="dropdown">
				<router-link class="inlineBlock" to="/" v-if="$.get_cookies('roleType')!=3">
					<el-dropdown-item>
						首页
					</el-dropdown-item>
				</router-link>
				<el-dropdown-item divided>
					<span @click="changePass" style="display:block;">修改密码</span>
				</el-dropdown-item>
				<el-dropdown-item divided>
					<span @click="logout" style="display:block;">退出</span>
				</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
		<!-- 编辑弹出框 -->
		<el-dialog title="修改密码" :visible.sync="passwordVisible" width="45%">
			<el-form ref="passwordForm" :model="passwordForm" :rules="rules" label-width="100px">
				<el-form-item label="旧密码" prop="oldPassword">
					<el-input type="password" class="handle-input" v-model="passwordForm.oldPassword"
						placeholder="旧密码"></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="password">
					<el-input type="password" class="handle-input" v-model="passwordForm.password" placeholder="新密码"></el-input>
				</el-form-item>
				<el-form-item label="重复新密码" prop="repassword">
					<el-input type="password" class="handle-input" v-model="passwordForm.repassword"
						placeholder="重复新密码"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="passwordVisible = false">取 消</el-button>
				<el-button type="primary" @click="savePassword('passwordForm')">确 定</el-button>
			</span>
		</el-dialog>
	</el-menu>
</template>

<script>
	import {
		mapGetters
	} from 'vuex'
	import Breadcrumb from '@/components/Breadcrumb'
	import Hamburger from '@/components/Hamburger'
	import {
		updateMyPassword
	} from '@/api/adminUser'

	export default {
		components: {
			Breadcrumb,
			Hamburger
		},
		data() {
			let validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入新密码'))
				} else if (value !== this.passwordForm.password) {
					callback(new Error('两次输入密码不一致!'))
				} else {
					callback()
				}
			}
			return {
				passwordVisible: false,
				passwordForm: {
					oldPassword: "",
					password: "",
					repassword: ""
				},
				rules: {
					oldPassword: [{
						required: true,
						message: '请输入旧密码',
						trigger: 'blur'
					}, ],
					password: [{
						required: true,
						message: '请输入新密码',
						trigger: 'blur'
					}, ],
					repassword: [{
						required: true,
						validator: validatePass,
						trigger: 'blur'
					}]
				}
			}
		},
		computed: {
			...mapGetters([
				'sidebar',
				'avatar'
			])
		},
		methods: {
			toggleSideBar() {
				this.$store.dispatch('ToggleSideBar')
			},
			logout() {
				this.$store.dispatch('LogOut').then(() => {
					location.reload() // 为了重新实例化vue-router对象 避免bug
				})
			},
			changePass() {
				this.passwordVisible = true;
			},
			savePassword(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$confirm('是否提交数据', '提示', {
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							updateMyPassword(this.passwordForm).then(response => {
								this.$refs[formName].resetFields();
								this.$message({
									message: '修改成功',
									type: 'success',
									duration: 1000
								});
								this.passwordVisible = false;
							});
						});

					} else {
						this.$message({
							message: '验证失败',
							type: 'error',
							duration: 1000
						});
						return false;
					}
				});
			}
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	.navbar {
		height: 50px;
		line-height: 50px;
		border-radius: 0px !important;

		.hamburger-container {
			line-height: 58px;
			height: 50px;
			float: left;
			padding: 0 10px;
		}

		.screenfull {
			position: absolute;
			right: 90px;
			top: 16px;
			color: red;
		}

		.avatar-container {
			height: 50px;
			display: inline-block;
			position: absolute;
			right: 35px;

			.avatar-wrapper {
				cursor: pointer;
				margin-top: 5px;
				position: relative;

				.user-avatar {
					width: 40px;
					height: 40px;
					border-radius: 10px;
				}

				.el-icon-caret-bottom {
					position: absolute;
					right: -20px;
					top: 25px;
					font-size: 12px;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue